<template>
  <div class="container">
    <div class="video-close" @click="closevideo"></div>
    <div class="video-wrap">
      <video-player
        class="video-player-box"
        ref="videoPlayer"
        :options="playerOptions"
        :playsinline="true"
        customEventName="customstatechangedeventname"
      ></video-player>
    </div>
  </div>
</template>
<script>
import { videoPlayer } from "vue-video-player";
export default {
  name: "videplay",
  props: {
    videoSrc: {
      type: String
    },
    autoplay: {
      type: Boolean,
      default: false
    }
  },
  components: {
    videoPlayer
  },
  data() {
    return {
      playerOptions: {
        autoplay: true, //自动播放
        muted: false, // 默认情况下将会消除任何音频。
        language: "en",
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        sources: [],
        // poster: "/static/images/author.jpg",//视频的封面地址
        fluid: true, //比例缩放以适应其容器
        notSupportedMessage: "此视频暂无法播放，请稍后再试" //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        //  controlBar: {
        //    timeDivider: true,
        //    durationDisplay: true,
        //    remainingTimeDisplay: false,
        //    fullscreenToggle: true  //全屏按钮
        //  }
      }
    };
  },
  methods: {
    //自调用播放方法
    onPlayerPlay(player) {
      const myPlayer = this.$refs.videoPlayer.player;

      myPlayer.play();
    },
    closevideo() {
      this.$emit("closevideo");
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  mounted() {
    // this.onPlayerPlay();
  },
  created() {
    this.playerOptions.sources.push({
      type: "video/mp4",
      src: this.videoSrc
    });
    //   if(this.autoplay){//为true代表自动播放
    //        this.onPlayerPlay();
    //   }
  }
};
</script>
<style lang="less" scoped>
@deep: ~">>>";
.container {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  z-index: 12;

  .video-close {
    position: absolute;
    right: 14px;
    top: 14px;
    width: 40px;
    height: 34px;
  }

  .video-close::before,
  .video-close::after {
    position: absolute;
    content: " ";
    background-color: #999;
    left: 20px;
    width: 2px;
    height: 34px;
  }

  .video-close::before {
    transform: rotate(45deg);
  }

  .video-close::after {
    transform: rotate(-45deg);
  }

  .video-close:hover:before,
  .video-close:hover:after {
    background-color: #5485e8;
  }
}
.video-wrap {
  width: 70%;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
@{deep} .video-js .vjs-big-play-button {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/video-play.vue